import React from 'react'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import xcadToken from '~img/landing/xcad-token.png'
import useXcadPrice from '~hooks/useXcadPrice'
import cn from 'classnames'
import * as s from './Hero.module.scss'

const Hero = () => {
  const xcadPrice = useXcadPrice()
  const { t } = useTranslation()
  return (
    <div className={cn(s.heroWrapper, 'container')}>
      <div className={s.start}>{t('startToday')}</div>
      <div className={s.content}>
        <div className={s.xcadPrice}>
          <h2 className={s.heroTitle}>{t('buyNow')}</h2>
          <img src={xcadToken} alt="xcad coin" />
          <div>
            <p
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                lineHeight: 'normal',
              }}
            >
              {t('tokenPrice')}
              <span>${xcadPrice}</span>
            </p>
          </div>
        </div>
        <div className={s.xcadDescription}>{t('description')}</div>
      </div>
    </div>
  )
}

export default Hero
